/** Splunk's logo URL. */
export const SplunkIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Splunk_logo.svg/3840px-Splunk_logo.svg.png";
